import { AnimatePresence, motion } from "framer-motion";
import { Plus } from "lucide-react";

export default function FAQAccordion({ items }) {
  return (
    <div className="space-y-3">
      {items.map((f, i) => (
        <motion.div
          key={i}
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ delay: i * 0.04, duration: 0.5 }}
          className="overflow-hidden rounded-2xl border border-white/10 bg-coal/70"
          data-testid={`faq-item-${i}`}
        >
          <details className="group">
            <summary className="flex cursor-pointer list-none items-center justify-between gap-4 px-6 py-5 font-semibold text-white transition-colors group-hover:text-gold [&::-webkit-details-marker]:hidden">
              <span className="text-[15px] leading-7">{f.q}</span>
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-gold/40 text-gold transition-transform duration-300 group-open:rotate-45">
                <Plus size={16} />
              </span>
            </summary>
            <div className="border-t border-white/5 px-6 pb-6 pt-4">
              <p className="text-sm leading-8 text-mist">{f.a}</p>
            </div>
          </details>
        </motion.div>
      ))}
    </div>
  );
}
